import { render, staticRenderFns } from "./WonderStrategyPanorama.vue?vue&type=template&id=0ae49cdb&scoped=true"
import script from "./WonderStrategyPanorama.vue?vue&type=script&lang=js"
export * from "./WonderStrategyPanorama.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyPanorama.vue?vue&type=style&index=0&id=0ae49cdb&prod&scoped=true&lang=css"
import style1 from "./WonderStrategyPanorama.vue?vue&type=style&index=1&id=0ae49cdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae49cdb",
  null
  
)

export default component.exports